import type { FC } from 'react'
import { Button, Flex } from '@/components'

import {
  SC_DocumentCard,
  SC_DocumentCardBody,
  SC_DocumentCardContent,
} from './styled'

type T_DocumentCardProps = {
  title: string
  description?: string
  onRead: () => void
}

export const DocumentCard: FC<T_DocumentCardProps> = ({
  title,
  description,
  onRead,
}) => {
  return (
    <SC_DocumentCard>
      <SC_DocumentCardBody>
        <SC_DocumentCardContent>
          <h5>{title}</h5>
          {description && <p>{description}</p>}
        </SC_DocumentCardContent>
        <Flex align='center' justify='flex-end'>
          <Button type='primary' onClick={onRead}>
            Читать
          </Button>
        </Flex>
      </SC_DocumentCardBody>
    </SC_DocumentCard>
  )
}
